import type JournalEvent from "parog-web/models/journal-event";
import { sortBy } from "./sort";

export default function groupJesByDate<T extends JournalEvent>(
  jes: T[],
  additionalCompute?: (jes: T[]) => void
): Record<string, T[]> {
  return jes.sort(sortBy("occurredAt", "desc")).reduce(
    (object: Record<string, T[]>, je: T) => {
      const date = Intl.DateTimeFormat("fr-fr", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }).format(je.occurredAt);

      if (!object.hasOwnProperty(date)) {
        object[date] = [];
      }

      (object[date] as T[]).push(je);
      additionalCompute?.(object[date] as T[]);

      return object;
    },
    {} as Record<string, T[]>
  );
}
